export default {
  props: {
    treatment: {},
    treatmentIndex: Number,
  }, 
};
